<template>
    <div>
        <loading
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="true"
            :height="150"
            :width="150"
            :color="'#FFFF00'"
            :background-color="'#000000'"
            :opacity="0.5"
        ></loading>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.pageTitle }}<span class="page_title_value">{{ this.pageTitleValue }}</span></h2>
                </v-row>

                <v-row>
                    <div class="pb-5 pl-4">
                        <v-btn 
                            color="warning" 
                            style="width: 100px" 
                            @click="backHandler"> 
                            {{$t('button.back')}}
                        </v-btn>
                    </div>
                </v-row>
                
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                <v-row>
                    <v-col>
                    <v-toolbar flat>
                        <v-toolbar-title>{{$t('payrolldashboardreport.payrollsummaryfor')}} <span class="blue--text"> {{data.formData.pyyear}}/{{data.formData.pymonth}}  </span></v-toolbar-title>
                    </v-toolbar>
                    <v-card elevation="2" rounded="lg" style="border:1px solid #E8EDF5;overflow:hidden;">
                        <div style="background:linear-gradient(135deg,#4F6BFF 0%,#7C3AFF 100%);height:4px;"></div>
                        <div class="ma-4">
                            <v-row>
                                <v-col class="pb-n4 mb-n8 mr-n3">
                                    <div class="db-stat-card db-stat-blue">
                                        <div class="db-stat-label">{{$t('reportsparam.year')}}</div>
                                        <div class="db-stat-value">{{data.formData.pyyear}}</div>
                                    </div>
                                </v-col>

                                <v-col class="pb-n4 mb-n8 mr-n3">
                                    <div class="db-stat-card db-stat-blue">
                                        <div class="db-stat-label">{{$t('reportsparam.month')}}</div>
                                        <div class="db-stat-value">{{data.formData.pymonth}}</div>
                                    </div>
                                </v-col>

                                <v-col cols="2" class="pb-n4 mb-n8 mr-n3">
                                    <div class="db-stat-card db-stat-purple">
                                        <div class="db-stat-label">{{$t('reportsparam.payout')}}</div>
                                        <div class="db-stat-value db-stat-value-sm">{{payoutname}}</div>
                                    </div>
                                </v-col>

                                <v-col cols="3" class="pb-n5 mr-n3">
                                    <div class="db-stat-card db-stat-green db-clickable" @click="goToDetail">
                                        <div class="db-stat-label">{{$t('payrolldashboardreport.totalpaid')}}</div>
                                        <div class="db-stat-value">{{payoutDetail.totalpaid}}</div>
                                        <div class="db-stat-hint">↗ Click to view details</div>
                                    </div>
                                </v-col>

                                <v-col cols="2" class="pb-n5 mr-n3">
                                    <div class="db-stat-card db-stat-indigo">
                                        <div class="db-stat-label">{{$t('payrolldashboardreport.paxprocessed')}}</div>
                                        <div class="db-stat-value">{{totalStaff}}</div>
                                    </div>
                                </v-col>

                                <v-col cols="2" class="pb-n5">
                                    <div class="db-stat-card db-stat-orange">
                                        <div class="db-stat-label">N | A | R</div>
                                        <div class="db-nar-row">
                                            <span class="db-nar-item db-nar-new">{{newJoiner}}</span>
                                            <span class="db-nar-sep">|</span>
                                            <span class="db-nar-item db-nar-active">{{availableStaff}}</span>
                                            <span class="db-nar-sep">|</span>
                                            <span class="db-nar-item db-nar-resign">{{resignStaff}}</span>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row class="pt-10">
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-primary">
                                        <div class="db-amount-label">{{$t('previewpayroll.grosspay')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.grossPay }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-success">
                                        <div class="db-amount-label">{{$t('previewpayroll.netpay')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.netPay }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-purple">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.companyfringe')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.companyFringe }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-primary">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.basic')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.basic }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-teal">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.allowance')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.allowance }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-teal">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.reimbursement')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.reimbursement }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-orange">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.overtime')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.overtime }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-orange">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.bonus')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.bonus }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-red">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.generaldeductions')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.generalDeductions }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-red">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.staffstatutorydeductions')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.staffStatutoryDeductions }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-red">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.companystatutorydeductions')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.companyStatutoryDeductions }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                        </div>
                        
                    </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" sm="6" class="pb-4 mt-8">
                        <v-card>
                            <div>
                                <app-charts ref="realtimeChart" type="bar" :options="options" :series="series">

                                </app-charts>
                            </div>
                        </v-card>
                    </v-col>

                    <v-col cols="6" sm="6" class="pb-4 mt-8">
                        <v-card>
                            <div>
                                <app-charts type="donut" :options="donutOptions" :series="donutSeries">

                                </app-charts>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>

                </v-container>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        'app-charts': VueApexCharts,
        Loading,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            pageTitle: this.$t('payrolldashboardreport.payrolldashboardsummary'),
            pageTitleValue: '',

            data: {
                formData: {
                    pyyear: this.$route.params.formData.pyyear,
                    pymonth: this.$route.params.formData.pymonth,
                    poid: this.$route.params.formData.poid,
                },

                parameters: {
                    brchid: this.$route.params.param.brchid,
                    compnyid: this.$route.params.param.compnyid,
                    deptid: this.$route.params.param.deptid,
                    emptypeid: this.$route.params.param.emptypeid,
                    gradeid: this.$route.params.param.gradeid,
                    staffid: this.$route.params.param.staffid,
                },
            },

            dashboardItemsHolder: {
                grossPay: null,
                netPay: null,
                companyFringe: null,
                basic: null,
                allowance: null,
                reimbursement: null,
                overtime: null,
                bonus: null,
                stat: null,
                ndedt: null,
                npay: null,
                generalDeductions: null,
                staffStatutoryDeductions: null,
                companyStatutoryDeductions: null,
            },
            payoutname: null,

            payoutDetail: {
                totalpaid: null,
            },

            dashboardItems: {
                grossPay: null,
                netPay: null,
                companyFringe: null,
                basic: null,
                allowance: null,
                reimbursement: null,
                overtime: null,
                bonus: null,
                stat: null,
                ndedt: null,
                npay: null,
                generalDeductions: null,
                staffStatutoryDeductions: null,
                companyStatutoryDeductions: null,
            },
            totalStaff: null,
            availableStaff: null,
            newJoiner: null,
            resignStaff: null,
            itemData: {
                itemcode: null,
                itemdesc: null,
                itemstamp: 0
            },
            tabHeader: [
                { text: this.$t('columns.no'), value: 'action', sortable: false, width: '5px' },
                { text: this.$t('setuppayitmetype.payitemtype'), value: 'code', width: '50px', sortable: false},
                { text: this.$t('setuppayitem.payitem'), value: 'desc', width: '200px', sortable: false },
                { text: this.$t('payslipreport.amt+ve'), value: 'action', sortable: false, width: '5px' },
                { text: this.$t('payrolldashboardreport.subttl+ve'), value: 'code', width: '50px', sortable: false},
                { text: this.$t('payslipreport.amt-ve'), value: 'desc', width: '50px', sortable: false },
                { text: this.$t('payrolldashboardreport.subttl-ve'), value: 'desc', width: '50px', sortable: false },
            ],
            options: {
                plotOptions: {
                    bar: {
                        distributed: true
                    }

                    
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: this.$t('columns.company')
                    }
                },
                yaxis: {
                    title: {
                        text: this.$t('setuppersonpayrolldirectassignment.amount')
                    },
                },
                title: {
                    text: this.$t('payrolldashboardreport.totalpaidoutbycompany')
                },
            },
            series: [{
                data: []
            }],



            donutOptions: {
                
                 chart: {
                    type: 'donut',

                    toolbar:{
                             show: true,
                             offsetX: 0,
                             offsetY: 0,

                             tools: {
                                download: true,
                                selection: true,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: true,
                                reset: true | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: []
                                },

                                export : {
                                    csv: {
                                        filename: "Payroll Donut Chart",
                                        columnDelimiter: ',',
                                        headerCategory: 'category',
                                        headerValue: 'value',
                                        dateFormatter(timestamp) {
                                        return new Date(timestamp).toDateString()
                                        }
                                    },

                                    svg: {
                                        filename: "Payroll Donut Chart",
                                    },

                                    png: {
                                         filename: "Payroll Donut Chart",
                                    }
                                },

                                autoSelected: 'zoom' 
                        }    
                },

                labels: [
                    'Basic',
                    'Allowance',
                    'Reimbursement',
                    'Overtime',
                    'Bonus',
                    'Deductions',
                    'Statutory',
                    'Non-Payable',
                    'Non-Deductable',
                ],
            },
            donutSeries: [],
            tpbc: [],
            tpbch: [],
            
            errMsg: '',
            isErr: false,
            loading: false,
        }
    },

    methods: {

        totalPaid() {
            return new Promise((resolve) => {
                const vm = this;

                let totalpaidholder = [
                    vm.dashboardItemsHolder.netPay,
                    vm.dashboardItemsHolder.companyFringe,
                    vm.dashboardItemsHolder.staffStatutoryDeductions,
                    vm.dashboardItemsHolder.companyStatutoryDeductions,
                ]

                let totalpaidsum = totalpaidholder.reduce((a, b) => a + b, 0);

                vm.payoutDetail.totalpaid = totalpaidsum.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                resolve(vm.payoutDetail.totalpaid);
            });
            
        },

        totalPaidbyCompany() {
            return new Promise((resolve) => {
                const vm = this

                let utpbch = []

                for (let i = 0; i < vm.tpbch.length; i++) {
                    if (utpbch.indexOf(vm.tpbch[i]) === -1 ) utpbch.push(vm.tpbch[i])
                }

                vm.tpbc.forEach(element => {
                    if (element.netpayamount) element.amount = parseFloat(element.netpayamount.replace(/,/g, ''))
                    if (element.companyfringe) element.amount = parseFloat(element.companyfringe.replace(/,/g, ''))
                    if (element.statutorydeduction) element.amount = parseFloat(element.statutorydeduction.replace(/,/g, ''))
                    //if (element.statutorydeduction) element.amount = parseFloat(element.statutorydeduction.replace(/,/g, ''))
                });

                for (let i = 0; i < utpbch.length; i++) {
                    let val = []
                    
                    vm.tpbc.forEach(element => {
                        if (utpbch[i] == element.compnydesc) {
                            val.push(element.amount)
                        }
                    });

                    let totalpaidsum = val.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.series[0].data.push(totalpaidsum.toFixed(2))
                    vm.options.xaxis.categories.push(utpbch[i])
                }

                resolve({
                    series: vm.series,
                    categories: vm.options.xaxis.categories
                });
            });

            
        },

        loadPayoutControl() {
            const vm = this;

            return this.$store.dispatch('get', {url: "/payoutctrl/" + vm.data.formData.poid})
            .then((res) => {
                
                let payout = res.data.rec[0];
                vm.payoutname = payout.payoutdesc
                vm.data.formData.pyyear = payout.pyyear
                vm.data.formData.pymonth = payout.pymonth
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        async loadDonut() {
            const vm = this;
            
            // setTimeout(() => {
            //     vm.donutSeries = [
            //         vm.dashboardItemsHolder.basic,
            //         vm.dashboardItemsHolder.allowance,
            //         vm.dashboardItemsHolder.reimbursement,
            //         vm.dashboardItemsHolder.overtime,
            //         vm.dashboardItemsHolder.bonus,
            //         vm.dashboardItemsHolder.generalDeductions,
            //         vm.dashboardItemsHolder.stat,
            //         vm.dashboardItemsHolder.ndedt,
            //         vm.dashboardItemsHolder.npay,
            //     ]
            //     this.totalPaid();
            //     this.totalPaidbyCompany();
            //     this.updateSeriesLine();
            // }, 1500);

            const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

            await sleep(1500);

            vm.donutSeries = [
                vm.dashboardItemsHolder.basic,
                vm.dashboardItemsHolder.allowance,
                vm.dashboardItemsHolder.reimbursement,
                vm.dashboardItemsHolder.overtime,
                vm.dashboardItemsHolder.bonus,
                vm.dashboardItemsHolder.generalDeductions,
                vm.dashboardItemsHolder.stat,
                vm.dashboardItemsHolder.ndedt,
                vm.dashboardItemsHolder.npay,
            ];
            await this.totalPaid();
            await this.totalPaidbyCompany();
            await this.updateSeriesLine();
        },

        updateSeriesLine() {
            return this.$refs.realtimeChart.updateSeries([{
                data: this.series[0].data,
            }], false, true);
        },

        async loadNewJoiner() {
            const vm = this;

            try {
            //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
            const res = await this.$store.dispatch('post', {url: `/payrolldashboard/newjoiner/${this.$store.getters.userId}`, payload: this.data})
            
                let newJoinerHolder = res.data.rec;
                vm.newJoiner = newJoinerHolder.length;
                await this.loadAvailableStaff();
            }
            catch(err) {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            }
        },

        async loadResign() {
            const vm = this;
            
            try {
                //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
                const res = await this.$store.dispatch('post', {url: `/payrolldashboard/resign/${this.$store.getters.userId}`, payload: this.data})
            
                let resignHolder = res.data.rec;
                vm.resignStaff = resignHolder.length;
                await vm.loadAvailableStaff();
            }
            catch(err) {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            }
            
        },

        async loadTotalStaff() {
            const vm = this;

            try {
            //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
            const res = await this.$store.dispatch('post', {url: `/payrolldashboard/totalstaff/${this.$store.getters.userId}`, payload: this.data})
            
                let totalStaffHolder = res.data.rec;
                vm.totalStaff = totalStaffHolder.length;
                await vm.loadAvailableStaff();
            }
            catch(err) {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            }
        
        },

        loadAvailableStaff() {
            const vm = this;
            return vm.availableStaff = vm.totalStaff - vm.newJoiner - vm.resignStaff
        },

        // loadDelay() {
        //     setTimeout(() => {
        //         this.loadNewJoiner();
        //         this.loadResign();
        //     }, 300);
        //     setTimeout(() => {
        //         this.loadAvailableStaff();
        //     }, 800);
        // },

        loadGrossPay() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/grosspay/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let grossPay = res.data.rec;
                    let grossPayHolder = []

                    grossPay.forEach(element => {
                        grossPayHolder.push(parseFloat(element.grosspayamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.grossPay = grossPayHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.grossPay = vm.dashboardItemsHolder.grossPay.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                } else {
                    vm.dashboardItemsHolder.grossPay = 0
                    vm.dashboardItems.grossPay =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadNetPay() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/netpay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/netpay/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let netPay = res.data.rec;
                    let netPayHolder = []
                    

                    netPay.forEach(element => {
                        netPayHolder.push(parseFloat(element.netpayamount.replace(/,/g, '')))
                        if (element.compnydesc) vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.netPay = netPayHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.netPay = vm.dashboardItemsHolder.netPay.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                } else {
                    vm.dashboardItemsHolder.netPay = 0
                    vm.dashboardItems.netPay =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadCompanyFringe() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/companyfringe ', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/companyfringe/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let companyFringe = res.data.rec;
                    let companyFringeHolder = []

                    companyFringe.forEach(element => {
                        companyFringeHolder.push(parseFloat(element.companyfringe.replace(/,/g, '')))
                        if (element.compnydesc) vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.companyFringe = companyFringeHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.companyFringe = vm.dashboardItemsHolder.companyFringe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.companyFringe = 0
                    vm.dashboardItems.companyFringe =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadBasic() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/basic', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/basic/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let basic = res.data.rec;
                    let basicHolder = []

                    basic.forEach(element => {
                        basicHolder.push(parseFloat(element.basicamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.basic = basicHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.basic = vm.dashboardItemsHolder.basic.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.basic = 0
                    vm.dashboardItems.basic =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadAllowance() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/allowance', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/allowance/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let allowance = res.data.rec;
                    let allowanceHolder = []

                    allowance.forEach(element => {
                        allowanceHolder.push(parseFloat(element.allowanceamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.allowance = allowanceHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.allowance = vm.dashboardItemsHolder.allowance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.allowance = 0
                    vm.dashboardItems.allowance =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadReimbursement() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/reimbursement', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/reimbursement/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let reimbursement = res.data.rec;
                    let reimbursementHolder = []

                    reimbursement.forEach(element => {
                        reimbursementHolder.push(parseFloat(element.reimbursementamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.reimbursement = reimbursementHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.reimbursement = vm.dashboardItemsHolder.reimbursement.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.reimbursement = 0
                    vm.dashboardItems.reimbursement =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadOvertime() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/overtime', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/overtime/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let overtime = res.data.rec;
                    let overtimeHolder = []

                    overtime.forEach(element => {
                        overtimeHolder.push(parseFloat(element.overtimeamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.overtime = overtimeHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.overtime = vm.dashboardItemsHolder.overtime.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.overtime = 0
                    vm.dashboardItems.overtime =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadBonus() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/bonus', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/bonus/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let bonus = res.data.rec;
                    let bonusHolder = []

                    bonus.forEach(element => {
                        bonusHolder.push(parseFloat(element.bonusamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.bonus = bonusHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.bonus = vm.dashboardItemsHolder.bonus.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.bonus = 0
                    vm.dashboardItems.bonus =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadGeneralDeduction() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/generaldeduction', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/generaldeduction/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let generalDeductions = res.data.rec;
                    let generalDeductionsHolder = []

                    generalDeductions.forEach(element => {
                        generalDeductionsHolder.push(parseFloat(element.generaldeduction.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.generalDeductions = generalDeductionsHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.generalDeductions = vm.dashboardItemsHolder.generalDeductions.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.generalDeductions = 0
                    vm.dashboardItems.generalDeductions =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadStatutoryDeductionStaff() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/statutorydeductionstaff', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/statutorydeductionstaff/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let statutoryDeductionsStaff = res.data.rec;
                    let statutoryDeductionsStaffHolder = []

                    statutoryDeductionsStaff.forEach(element => {
                        statutoryDeductionsStaffHolder.push(parseFloat(element.statutorydeduction.replace(/,/g, '')))
                        if (element.compnydesc) vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.staffStatutoryDeductions = statutoryDeductionsStaffHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.staffStatutoryDeductions = vm.dashboardItemsHolder.staffStatutoryDeductions.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.staffStatutoryDeductions = 0
                    vm.dashboardItems.staffStatutoryDeductions =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadStatutoryDeductionCompany() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/statutorydeductioncompany', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/statutorydeductioncompany/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let statutoryDeductionsCompany = res.data.rec;
                    let statutoryDeductionsCompanyHolder = []

                    statutoryDeductionsCompany.forEach(element => {
                        statutoryDeductionsCompanyHolder.push(parseFloat(element.statutorydeduction.replace(/,/g, '')))
                        vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.companyStatutoryDeductions = statutoryDeductionsCompanyHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.companyStatutoryDeductions = vm.dashboardItemsHolder.companyStatutoryDeductions.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.companyStatutoryDeductions = 0
                    vm.dashboardItems.companyStatutoryDeductions =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadStat() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/stat', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/stat/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let stat = res.data.rec;
                    let statHolder = []

                    stat.forEach(element => {
                        statHolder.push(parseFloat(element.statamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.stat = statHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.stat = vm.dashboardItemsHolder.stat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.stat = 0
                    vm.dashboardItems.stat =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadNPay() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/npay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/npay/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let npay = res.data.rec;
                    let npayHolder = []

                    npay.forEach(element => {
                        npayHolder.push(parseFloat(element.npayamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.npay = npayHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.npay = vm.dashboardItemsHolder.npay.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.npay = 0
                    vm.dashboardItems.npay =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadNDedt() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/basic', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/ndedt/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let ndedt = res.data.rec;
                    let ndedtHolder = []

                    ndedt.forEach(element => {
                        ndedtHolder.push(parseFloat(element.ndedtamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.ndedt = ndedtHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.ndedt = vm.dashboardItemsHolder.ndedt.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.ndedt = 0
                    vm.dashboardItems.ndedt =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        goToDetail() {
            let formData = this.data.formData
            let param = this.data.parameters

            this.$router.push({name: 'payrolldashboarddetail', params: { formData, param }});
        },

        backHandler() {
            let formData = this.data.formData
            let param = this.data.parameters

            this.$router.push({name: 'payrolldashboardfilter', params: { formData, param } });
        },
    },

    async mounted() {
        this.loading = true;
        try {
            await this.loadPayoutControl();
            await this.loadGrossPay();
            await this.loadNetPay();
            await this.loadBasic();
            await this.loadCompanyFringe();
            await this.loadAllowance();
            await this.loadReimbursement();
            await this.loadOvertime();
            await this.loadBonus();
            await this.loadStat();
            await this.loadNPay();
            await this.loadNDedt();
            await this.loadStatutoryDeductionStaff();
            await this.loadStatutoryDeductionCompany();
            await this.loadGeneralDeduction();
            await this.loadDonut();
            await this.loadTotalStaff();
            await this.loadNewJoiner();
            await this.loadResign();
        } finally {
            this.loading = false;
        }
    }
    
}
</script>

<style scoped>
/* ── Top stat cards ── */
.db-stat-card {
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    height: 100%;
    border: 1px solid transparent;
}
.db-stat-label {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    opacity: 0.7;
}
.db-stat-value {
    font-size: 1.5rem;
    font-weight: 800;
    line-height: 1.1;
}
.db-stat-value-sm { font-size: 1rem; }
.db-stat-hint { font-size: 0.68rem; opacity: 0.55; margin-top: 2px; }
.db-clickable { cursor: pointer; transition: transform 0.15s, box-shadow 0.15s; }
.db-clickable:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(0,0,0,0.12); }

.db-stat-blue   { background:#EEF2FF; color:#4F6BFF; border-color:#C7D2FE; }
.db-stat-purple { background:#F5F3FF; color:#7C3AFF; border-color:#DDD6FE; }
.db-stat-green  { background:#ECFDF5; color:#059669; border-color:#A7F3D0; }
.db-stat-indigo { background:#EEF2FF; color:#4338CA; border-color:#C7D2FE; }
.db-stat-orange { background:#FFF7ED; color:#D97706; border-color:#FDE68A; }

/* N|A|R row */
.db-nar-row { display:flex; align-items:center; gap:6px; font-size:1.3rem; font-weight:800; margin-top:4px; }
.db-nar-sep { color:#D97706; opacity:0.4; }
.db-nar-new    { color:#92400E; }
.db-nar-active { color:#92400E; }
.db-nar-resign { color:#92400E; }

/* ── Amount metric cards — clean single-colour ── */
.db-amount-card {
    border-radius: 14px;
    padding: 0;
    border: none;
    height: 100%;
    overflow: hidden;
    background: #F8FAFF;
    border: 1px solid #E0E7FF;
    box-shadow: 0 2px 8px rgba(79,107,255,0.07);
    transition: transform 0.15s, box-shadow 0.15s;
}
.db-amount-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(79,107,255,0.13);
}
.db-amount-card::before {
    content: '';
    display: block;
    height: 4px;
    width: 100%;
    background: linear-gradient(90deg, #4F6BFF 0%, #7C3AFF 100%);
}
.db-amount-label {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: #64748B;
    padding: 12px 16px 4px;
}
.db-amount-value {
    font-size: 1.6rem;
    font-weight: 900;
    line-height: 1;
    letter-spacing: -0.02em;
    color: #3730A3;
    padding: 0 16px 16px;
}

/* all variants share the same look */
.db-amount-primary,
.db-amount-success,
.db-amount-purple,
.db-amount-teal,
.db-amount-orange,
.db-amount-red { background: #F8FAFF; border-color: #E0E7FF; }

.db-amount-primary .db-amount-value,
.db-amount-success .db-amount-value,
.db-amount-purple .db-amount-value,
.db-amount-teal .db-amount-value,
.db-amount-orange .db-amount-value,
.db-amount-red .db-amount-value { color: #3730A3; }

.db-amount-primary .db-amount-label,
.db-amount-success .db-amount-label,
.db-amount-purple .db-amount-label,
.db-amount-teal .db-amount-label,
.db-amount-orange .db-amount-label,
.db-amount-red .db-amount-label { color: #64748B; }
</style>